/**
 * Фиксация шапки
 *
 * @author      delphinpro <delphinpro@gmail.com>
 * @copyright   copyright © 2018 delphinpro
 * @license     licensed under the MIT license
 */



function fixedHeader() {

    let $container = $('#wrapper');
    let $window    = $(window);
    let $header    = $('.header');
    let $navi      = $('.header_block_two');// TODO replace fixed_block_two
    let fixedHeight;
    let isFixed;

    function initState() {
        fixedHeight = $header.height();
        $container.css({paddingTop: fixedHeight + 'px'});

        if ($window.scrollTop() >= 10) {
            isFixed = true;
            $header.addClass('header_fixed').removeClass('header_default');
        } else {
            isFixed = false;
            $header.removeClass('header_fixed').addClass('header_default');
        }
    }

    function checkScrollTop() {
        if ($window.scrollTop() >= 10) {
            $header.addClass('header_fixed').removeClass('header_default');
        } else {
            $header.removeClass('header_fixed').addClass('header_default');
        }
    }

    setTimeout(function() {
        // initState();
        // $window.on('scroll', checkScrollTop);
        // $window.on('resize', initState);
    }, 1000);
}

export default fixedHeader;
